import fileViewerTpl from './fileViewer.tpl.html';
import fileViewerCtrl from './fileViewer.controller';

export default {
    templateUrl: fileViewerTpl,
    controller: fileViewerCtrl,
    controllerAs: 'vm',
};
